import clsx from "clsx";
import { ICON_SIZES } from "../../helpers/constants";
import useMobile from "../../hooks/useMobile";
import { useTranslation } from "react-i18next";
import React from "react";
import { MdOutlineDataObject } from "react-icons/md";
import { motion } from "framer-motion";
import { IButton } from "../Button/Button";
import ButtonGroup from "../ButtonGroup/ButtonGroup";
import Icon from "../Icon/Icon";
import i18next from "i18next";

// const ANIMAL_ICONS = [MdOutlineDataObject];

// const RandomAnimalIcon =
//   ANIMAL_ICONS[Math.floor(Math.random() * ANIMAL_ICONS.length)];

interface INoTableData {
  className?: string;
  icon?: any;
  buttons?: IButton[];
  text?: string;
}

const NoTableData: React.FC<INoTableData> = ({
  className,
  icon,
  buttons = [],
  text = i18next.t("common.no_elements_to_show"),
}) => {
  const { isMobile } = useMobile();
  const { t } = useTranslation();

  return (
    <motion.div
      className={clsx([
        "flex",
        "w-full",
        "flex-col",
        "gap-2",
        "items-center",
        "justify-center",
        "px-2",
        "py-2",
        "md:my-[57px]",
        "my-[33px]",
        className,
      ])}
      initial={{
        y: 200,
        opacity: 0.5,
      }}
      animate={{
        y: 0,
        opacity: 1,
      }}
      exit={{
        y: 200,
        opacity: 0.5,
      }}
    >
      <motion.div
        animate={{
          rotate: [-5, 5, -5], // gira de -5° a 5° y regresa
        }}
        transition={{
          duration: 0.6,
          repeat: Infinity,
          repeatType: "loop",
          ease: "easeInOut",
        }}
        style={{ display: "inline-block" }}
        className={clsx(["dark:text-cyan-500", "text-gray-300"])}
      >
        {icon ? (
          <Icon
            name={icon}
            size={isMobile ? ICON_SIZES.XL * 2 : ICON_SIZES.XL * 3}
            className={clsx([
              "animate-bounce",
              "dark:text-cyan-600",
              "text-gray-200",
              "opacity-75",
            ])}
          />
        ) : (
          <MdOutlineDataObject
            size={isMobile ? ICON_SIZES.XL * 2 : ICON_SIZES.XL * 3}
            className={clsx([
              "animate-bounce",
              "dark:text-cyan-600",
              "text-gray-200",
              "opacity-75",
            ])}
          />
        )}
      </motion.div>

      <div
        className={clsx([
          "text-sm",
          "md:text-sm",
          // "dark:text-white",
          // "text-red-500",
          "animate-pulse",
        ])}
      >
        {text}
      </div>
      {buttons?.length > 0 && (
        <div className={clsx(["flex", "w-full", "mt-5", "justify-center"])}>
          <ButtonGroup buttons={buttons} align="center" />
        </div>
      )}
    </motion.div>
  );
};

export default React.memo(NoTableData);
